import { useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useGetDashboardGroups } from 'hooks/queries/dashboard';
import CoreSelect from 'shared/CoreSelect';

export type TOrdinalFilter = 'cardinal' | 'mission' | 'special';

const OrdinalFilter = () => {
	const [searchParams, setSearchParams] = useSearchParams();

	const { data: groups, isLoading } = useGetDashboardGroups();
	const selectedGroupId = searchParams.get('groupId');
	/** 월 선택 함수 */
	const setSelctedItem = (groupId: string) => {
		searchParams.set('groupId', groupId.split('기')[0]);
		setSearchParams(searchParams, { replace: true });
	};

	// 0000-00 형식의 문자열을 00월 형식으로 변환하는 함수
	const formatMonth = (monthString: string) => {
		const [year, month] = monthString.split('-');
		return `${parseInt(month, 10)}월`;
	};

	// selected_option 변환: groupId + groupMonth 형식
	const selectedOption = useMemo(() => {
		const selectedItem = groups?.find((item) => item.groupId === Number(selectedGroupId));
		if (selectedItem) {
			return `${selectedItem.groupId}기 (${formatMonth(selectedItem.groupMonth)})`;
		}
		if (groups && groups.length > 0) {
			return `${groups[groups.length - 1].groupId}기 (${formatMonth(
				groups[0].groupMonth,
			)})`;
		}
	}, [searchParams, groups]);

	//선택된 그룹이 없으면 가장 나중 그룹으로 한다.
	useEffect(() => {
		if (!isLoading && selectedGroupId === null && groups && groups.length > 0) {
			searchParams.set('groupId', groups[groups.length - 1].groupId.toString());
			setSearchParams(searchParams, { replace: true });
		}
	}, [isLoading, selectedGroupId, groups, searchParams, setSearchParams]);

	return (
		<CoreSelect
			_width="180px"
			_height="32px"
			select_type="box"
			default_quote=""
			// 보이는 값은 groupId+월 형식
			option_list={groups?.map(
				(item: { groupId: number; groupMonth: string }) =>
					`${item.groupId}기 (${formatMonth(item.groupMonth)})`,
			)}
			selected_option={selectedOption}
			// 선택된 값은 groupId
			setSelectedOption={(value: string) => {
				const groupId = value.split('기')[0];
				setSelctedItem(groupId);
			}}
		/>
	);
};

export default OrdinalFilter;
